import Udesk from 'Udesk';
import UdeskLocales from 'UdeskLocales';
import React, { useEffect, useMemo, useState } from 'react';
import { Tabs } from 'udesk-ui';
import Page from 'Component/common/udesk-qa-page-layout';
import SubRoutes from 'udesk-react/src/components/sub-routes';
import { getCurrentRouteName, isSalesSubApp } from 'Udesk/system/subApp';
import './style.scss';

function CollectionDataAdd(props) {
    const locales = UdeskLocales['current'];
    const company = Udesk.data.init.company ? Udesk.data.init.company : null;

    const ADD_TYPES = useMemo(
        () =>
            [
                {
                    pathName: getCurrentRouteName('systemIntegrationCCpass'),
                    key: 'ccpass',
                    text: locales.menu.admin.systemIntegration.subTitle[
                        Udesk.data.init.company.enabledWhiteSystem ? 'udeskWhite' : 'udesk'
                    ],
                    id: 'cc-pass',
                },
                {
                    pathName: getCurrentRouteName('wechatDocking'),
                    key: 'wechat',
                    text: locales.menu.admin.systemIntegration.subTitle.wechat,
                    id: 'wecom',
                },
                {
                    pathName: getCurrentRouteName('taobaoDocking'),
                    key: 'taobao',
                    text: locales.menu.admin.systemIntegration.subTitle.taobao,
                    id: 'taobao',
                    hidden: !Udesk.data.init.company.enabledMallInspect,
                },
                {
                    pathName: getCurrentRouteName('weifengDocking'),
                    key: 'weifeng',
                    text: locales.menu.admin.systemIntegration.subTitle.weifeng,
                    id: 'weifeng',
                },
                {
                    pathName: getCurrentRouteName('systemIntegrationZendesk'),
                    key: 'zendesk',
                    text: 'Zendesk',
                    id: 'zendesk',
                },
                {
                    pathName: getCurrentRouteName('kcsDocking'),
                    key: 'kcs',
                    text: 'KCS',
                    id: 'kcs',
                },
                {
                    pathName: getCurrentRouteName('systemIntegrationFeishu'),
                    key: 'feishu',
                    text: /* 飞书 */ UdeskLocales['current'].pages.systemIntegration.template
                        .flyingBook,
                    id: 'feishu',
                },
                {
                    pathName: getCurrentRouteName('voiceRobot'),
                    key: 'voiceRobot',
                    text: /* 语音机器人 */ UdeskLocales['current'].pages.systemIntegration.template
                        .voiceRobot,
                    id: 'voiceRobot',
                },
                {
                    pathName: getCurrentRouteName('systemIntegrationCoze'),
                    key: 'coze',
                    text: 'Coze',
                    id: 'coze',
                },
                {
                    pathName: getCurrentRouteName('integrationLLM'),
                    key: 'llm',
                    text: /* 大模型 */ UdeskLocales['current'].pages.systemIntegration.template
                        .largeModel,
                    id: 'llm',
                },
                {
                    pathName: getCurrentRouteName('systemIntegrationJdShop'),
                    key: 'jdShop',
                    text: /* 京东 */ UdeskLocales['current'].pages.systemIntegration.template
                        .jingdong,
                    id: 'jdShop',
                },
            ].filter((item) => {
                if (isSalesSubApp()) {
                    return item.id === 'cc-pass' || item.id === 'weifeng';
                } else {
                    return item.id !== 'weifeng' || (company && company.enabledWeComInspect !== 0);
                }
            }),
        [company, locales.menu.admin.systemIntegration.subTitle]
    );

    const [activeKey, setActiveKey] = useState<
        | 'ccpass'
        | 'wechat'
        | 'taobao'
        | 'weifeng'
        | 'kcs'
        | 'feishu'
        | 'voiceRobot'
        | 'coze'
        | 'jdShop'
    >('ccpass');

    const onAddTypeChange = (activeKey) => {
        setActiveKey(activeKey);
        const tab: any = ADD_TYPES.find((t) => t.key === activeKey) ?? {};
        const routeOptions = {
            history: props.history,
            routeName: tab.pathName,
            pathParams: { taskId: props.match.params.taskId },
        };
        Udesk.ui.routing.transitionTo(routeOptions);
    };

    useEffect(() => {
        const currentPath = ADD_TYPES.find(
            (item) => props.history.location.pathname.indexOf(item.id) >= 0
        );
        if (currentPath) {
            setActiveKey(currentPath.key as any);
        }
    }, [ADD_TYPES, props.history.location]);

    return (
        <Page
            pageBodyClassName="data-collection-add-page-index"
            title={locales.menu.admin.systemIntegration.text}
            padding={true}
        >
            <Tabs activeKey={activeKey} onChange={onAddTypeChange}>
                {props.routes.map((item, i) => {
                    const tab: any = ADD_TYPES.find((t) => t.pathName === item.name);

                    if (!tab || tab.hidden) return null;

                    return (
                        <Tabs.TabPane tab={tab.text} key={tab.key}>
                            <SubRoutes key={i} route={item} />
                        </Tabs.TabPane>
                    );
                })}
            </Tabs>
        </Page>
    );
}

export default React.memo(CollectionDataAdd);
